<!-- Main container for the redirect page -->
<div class="redirect-container">
  <!-- Content section including animation, messages, and rewards -->
  <div class="content-section">
    <!-- Lottie animation container -->
    <div class="animation-container">
      <div #lottieContainer></div>
    </div>
    <!-- Status message above reward card -->
    <span *ngIf="showRedirectingHeader && !showContinueButton"
      [ngStyle]="{ color: 'black', 'font-size': '14px' }">
      Loading in {{ countdown }}sec...
    </span>
    <span *ngIf="showContinueButton"
      [ngStyle]="{ color: 'rgb(35, 158, 10)', 'font-size': '14px' }">
      Loading is on Hold!
    </span>
    <!-- Shared reward card and how-to-redeem section -->
    <div class="reward-card">
      <div class="reward-header">
        <img
          src="../../assets/images/redirect.png"
          class="icon-sm"
          alt="Reward"
        />

        <span style="font-size: 24px;">Earn Rewards of ₹{{ point }} worth</span>
      </div>
    </div>
    <h4 class="how-to-redeem-title" style="font-size: 14px;">How to Redeem</h4>
    <div class="reward-section">
      <div class="how-to-redeem">
        <ol>
          <li>You will earn reward points by shopping on the brand’s page.</li>
          <li>Continue your shopping usually after landing to brand page.</li>
          <li>This reward point eligible for limited users.</li>
        </ol>
        <small class="terms">T&C applied</small>
      </div>
    </div>
    <!-- Shared message and button section -->
    <div class="redirect-message">
      <div
        class="redirect-header"
        [ngClass]="{ loaded: showContinueButton }"
      ></div>
      <div *ngIf="!showContinueButton" class="pause-section">
        <div class="pause-label" style="font-size: 14px;">Pause to Continue Reading</div>
        <button
          *ngIf="showCancelButton"
          class="pause-button"
          (click)="cancelRedirection()"
        >
          Pause
        </button>
      </div>
      <div *ngIf="showContinueButton" class="continue-section">
        <div class="continue-label">Finished Reading?</div>
        <button class="continue-button" (click)="continueRedirection()">
          Continue
        </button>
      </div>
    </div>
  </div>
</div>
